module.exports = __webpack_public_path__ + "img/login_bg.85f4574b.png";